export default __webpack_public_path__ + "static/media/lnc_logo.9f851ee5.png";